
function getShopifyAssetUrl(filename) {
  if (!filename) return '';
  var cleanName = filename.split('/').pop();
  if (window.RAHAT_STORE_ASSETS) {
    return window.RAHAT_STORE_ASSETS + cleanName;
  }
  if (window.GLOW_VIBES_ASSETS) {
    return window.GLOW_VIBES_ASSETS + cleanName;
  }
  return filename;
}
/**
 * ==========================================================================
 * RAHAT STORE - STORE FRONT & THEME ENGINE (rahatstore.pk)
 * Interactive E-Commerce & Dynamic Product Variant Engine
 * ==========================================================================
 */

document.addEventListener("DOMContentLoaded", () => {
  initAnnouncementBar();
  initStickyHeader();
  initHeroSlider();
  initTabbedCollections();
  initFeaturedVariantPicker();
  initCardVariantPickers();
  initCartDrawer();
  initCodQuickOrder();
  initSizeCalculator();
  initRecentSalesPopup();
  initViewAllProducts();
  initCategoriesModal();
  initCategoryQuickBar();
});

/**
 * 1. Announcement Bar Ticker
 */
function initAnnouncementBar() {
  const bar = document.querySelector(".announcement-ticker");
  if (!bar) return;
  const slides = bar.querySelectorAll(".announcement-slide");
  if (slides.length <= 1) return;

  let current = 0;
  setInterval(() => {
    slides[current].style.display = "none";
    current = (current + 1) % slides.length;
    slides[current].style.display = "flex";
  }, 4000);
}

/**
 * 2. Sticky Header with Scroll Threshold
 */
function initStickyHeader() {
  const header = document.querySelector(".site-header");
  if (!header) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
    }
  }, { passive: true });
}

/**
 * 3. Hero Banner Slider with Autoplay & Pagination
 */
function initHeroSlider() {
  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".hero-dot");
  if (!slides.length) return;

  let activeIndex = 0;
  let interval;

  function showSlide(index) {
    slides.forEach((s, i) => s.classList.toggle("active", i === index));
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
    activeIndex = index;
  }

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const idx = parseInt(dot.getAttribute("data-index") || "0", 10);
      showSlide(idx);
      resetAuto();
    });
  });

  function startAuto() {
    interval = setInterval(() => {
      let next = (activeIndex + 1) % slides.length;
      showSlide(next);
    }, 5500);
  }

  function resetAuto() {
    clearInterval(interval);
    startAuto();
  }

  startAuto();
}

/**
 * 4. Collection Tabs Filtering
 */
function initTabbedCollections() {
  const tabs = document.querySelectorAll(".tab-btn");
  const cards = document.querySelectorAll(".product-card");
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const filter = tab.getAttribute("data-filter");
      cards.forEach(card => {
        const cat = card.getAttribute("data-category");
        if (filter === "all" || cat === filter) {
          card.style.display = "flex";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
}

/**
 * 5. Featured Main Product: CeraVe 3-Variant Interactive Switcher
 * Supports dynamic size switching (85g, 340g, 454g)
 */
const CeraVeVariants = {
  "85g": {
    sizeTitle: "85g Travel Tube",
    price: 1650,
    comparePrice: 2200,
    discountTag: "SAVE 25%",
    image: "assets/images/catalog/IMG-20260910-WA0049.jpg",
    badge: "STARTER TRIAL",
    subtitle: "Compact on-the-go barrier hydration for face & hands"
  },
  "340g": {
    sizeTitle: "340g Family Tub",
    price: 3450,
    comparePrice: 4500,
    discountTag: "SAVE RS. 1,050 (BEST VALUE)",
    image: "assets/images/cerave/cerave-340g-1.webp",
    badge: "MOST POPULAR",
    subtitle: "Our #1 best-selling family tub with rich restorative ceramides"
  },
  "454g": {
    sizeTitle: "454g Jumbo Tub (16 oz)",
    price: 4200,
    comparePrice: 5400,
    discountTag: "SAVE RS. 1,200 (MEGA VALUE)",
    image: "assets/images/catalog/IMG-20260910-WA0047.jpg",
    badge: "JUMBO VALUE",
    subtitle: "Maximum economy tub with rich restorative ceramides"
  }
};

function initFeaturedVariantPicker() {
  const chips = document.querySelectorAll(".variant-btn-chip[data-variant-key]");
  const mainImg = document.getElementById("FeaturedProductMainImg");
  const currentPriceEl = document.getElementById("FeaturedPriceCurrent");
  const comparePriceEl = document.getElementById("FeaturedPriceCompare");
  const discountBadgeEl = document.getElementById("FeaturedDiscountBadge");
  const selectedLabelEl = document.getElementById("FeaturedSelectedLabel");
  const mainCodBtn = document.getElementById("FeaturedCodBtn");
  const mainCartBtn = document.getElementById("FeaturedCartBtn");

  if (!chips.length) return;

  chips.forEach(chip => {
    chip.addEventListener("click", () => {
      const key = chip.getAttribute("data-variant-key");
      const variant = CeraVeVariants[key];
      if (!variant) return;

      // Toggle active states
      chips.forEach(c => c.classList.remove("active"));
      chip.classList.add("active");

      // Update image smoothly
      if (mainImg) {
        mainImg.style.opacity = "0.3";
        setTimeout(() => {
          mainImg.src = getShopifyAssetUrl(variant.image);
          mainImg.style.opacity = "1";
        }, 150);
      }

      // Update price display
      if (currentPriceEl) currentPriceEl.textContent = `Rs. ${variant.price.toLocaleString()}`;
      if (comparePriceEl) comparePriceEl.textContent = `Rs. ${variant.comparePrice.toLocaleString()}`;
      if (discountBadgeEl) discountBadgeEl.textContent = variant.discountTag;
      if (selectedLabelEl) selectedLabelEl.textContent = `${variant.sizeTitle} (${variant.badge})`;

      // Update CTA buttons data attributes
      if (mainCodBtn) {
        mainCodBtn.setAttribute("data-title", `CeraVe Moisturising Cream (${variant.sizeTitle})`);
        mainCodBtn.setAttribute("data-price", variant.price);
        mainCodBtn.setAttribute("data-image", variant.image);
        mainCodBtn.setAttribute("data-variant", variant.sizeTitle);
        mainCodBtn.textContent = `⚡ Order Now (Rs. ${variant.price.toLocaleString()})`;
      }

      if (mainCartBtn) {
        mainCartBtn.setAttribute("data-title", `CeraVe Moisturising Cream (${variant.sizeTitle})`);
        mainCartBtn.setAttribute("data-price", variant.price);
        mainCartBtn.setAttribute("data-image", variant.image);
        mainCartBtn.setAttribute("data-variant", variant.sizeTitle);
        mainCartBtn.setAttribute("data-id", `cerave-${key}`);
      }
    });
  });
}

/**
 * 6. Dynamic Variant Picker on Product Cards
 * Any product with variants updates card image, price and actions dynamically
 */
function initCardVariantPickers() {
  document.addEventListener("click", e => {
    const pill = e.target.closest(".card-variant-pill");
    if (!pill) return;

    const card = pill.closest(".product-card");
    if (!card) return;

    // Toggle active pill in this card
    card.querySelectorAll(".card-variant-pill").forEach(p => p.classList.remove("active"));
    pill.classList.add("active");

    const size = pill.getAttribute("data-size");
    const price = parseInt(pill.getAttribute("data-price"), 10);
    const image = pill.getAttribute("data-image");

    // Update card image if provided
    if (image) {
      const primaryImg = card.querySelector(".primary-img");
      if (primaryImg) primaryImg.src = image;
    }

    // Update card price
    const priceEl = card.querySelector(".current-price");
    if (priceEl && !isNaN(price)) {
      priceEl.textContent = `Rs. ${price.toLocaleString()}`;
    }

    // Update button attributes
    const cartBtn = card.querySelector('[data-action="add-to-cart"]');
    const codBtn = card.querySelector('[data-action="quick-cod"]');

    if (cartBtn) {
      if (size) cartBtn.setAttribute("data-variant", size);
      if (!isNaN(price)) cartBtn.setAttribute("data-price", price);
      if (image) cartBtn.setAttribute("data-image", image);
    }

    if (codBtn) {
      if (size) codBtn.setAttribute("data-variant", size);
      if (!isNaN(price)) codBtn.setAttribute("data-price", price);
      if (image) codBtn.setAttribute("data-image", image);
    }
  });
}

/**
 * 7. Shopping Bag / Cart Drawer System with Free Shipping Progress
 */
const CartState = {
  items: [
    {
      id: "cerave-340g",
      title: "CeraVe Moisturising Cream (340g Family Tub)",
      variant: "340g Family Tub",
      price: 3450,
      qty: 1,
      image: "assets/images/cerave/cerave-340g-1.webp"
    }
  ],
  threshold: 2499,
  shippingFee: 199
};

function initCartDrawer() {
  const drawer = document.getElementById("CartDrawer");
  const overlay = document.getElementById("CartDrawerOverlay");
  const openBtns = document.querySelectorAll('[data-action="open-cart"]');
  const closeBtns = document.querySelectorAll('[data-action="close-cart"]');

  if (!drawer || !overlay) return;

  function openCart() {
    drawer.classList.add("active");
    overlay.classList.add("active");
    renderCart();
  }

  function closeCart() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
  }

  openBtns.forEach(btn => btn.addEventListener("click", e => {
    e.preventDefault();
    openCart();
  }));

  closeBtns.forEach(btn => btn.addEventListener("click", closeCart));
  overlay.addEventListener("click", closeCart);

  // Global Add to Cart listener
  document.addEventListener("click", e => {
    const addBtn = e.target.closest('[data-action="add-to-cart"]');
    if (!addBtn) return;
    e.preventDefault();

    const id = addBtn.getAttribute("data-id") || ("item-" + Date.now());
    const title = addBtn.getAttribute("data-title") || "Rahat Store Beauty Item";
    const price = parseInt(addBtn.getAttribute("data-price") || "1650", 10);
    const image = addBtn.getAttribute("data-image") || "assets/images/cerave/cerave-340g-1.webp";
    const variant = addBtn.getAttribute("data-variant") || "Standard";

    const existing = CartState.items.find(item => item.id === id && item.variant === variant);
    if (existing) {
      existing.qty += 1;
    } else {
      CartState.items.push({ id, title, price, qty: 1, image, variant });
    }

    openCart();
    updateHeaderCartCount();
  });

  renderCart();
  updateHeaderCartCount();
}

function renderCart() {
  const container = document.getElementById("CartDrawerItems");
  const subtotalEl = document.getElementById("CartSubtotal");
  const progressFill = document.getElementById("ShippingProgressFill");
  const progressText = document.getElementById("ShippingProgressText");

  if (!container) return;

  if (CartState.items.length === 0) {
    container.innerHTML = `
      <div style="text-align: center; padding: 60px 20px;">
        <div style="font-size: 42px; margin-bottom: 12px;">🛍️</div>
        <h4 style="font-size: 18px; margin-bottom: 6px;">Your bag is empty</h4>
        <p style="font-size: 14px; color: var(--color-text-muted); margin-bottom: 20px;">Explore our radiant skincare, undergarments & beauty collections to add your favorites.</p>
        <button class="btn btn-primary" data-action="close-cart">Explore Collections</button>
      </div>
    `;
    if (subtotalEl) subtotalEl.textContent = "Rs. 0";
    if (progressFill) progressFill.style.width = "0%";
    if (progressText) progressText.innerHTML = `Add Rs. ${CartState.threshold.toLocaleString()} more for <strong>FREE Nationwide Delivery</strong>!`;
    return;
  }

  let subtotal = 0;
  let html = "";

  CartState.items.forEach((item, idx) => {
    const itemTotal = item.price * item.qty;
    subtotal += itemTotal;

    html += `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.title}">
        <div class="cart-item-info">
          <h4 class="cart-item-title">${item.title}</h4>
          <p class="cart-item-variant">${item.variant}</p>
          <div class="cart-item-row">
            <div class="qty-stepper">
              <button class="qty-btn" onclick="updateItemQty(${idx}, -1)">-</button>
              <span class="qty-val">${item.qty}</span>
              <button class="qty-btn" onclick="updateItemQty(${idx}, 1)">+</button>
            </div>
            <div class="cart-item-price">Rs. ${itemTotal.toLocaleString()}</div>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = `Rs. ${subtotal.toLocaleString()}`;

  // Progress Bar for Free Shipping
  if (progressFill && progressText) {
    if (subtotal >= CartState.threshold) {
      progressFill.style.width = "100%";
      progressText.innerHTML = `🎉 <strong>Congratulations!</strong> You have unlocked FREE Nationwide Delivery!`;
    } else {
      const remaining = CartState.threshold - subtotal;
      const pct = Math.min(100, Math.round((subtotal / CartState.threshold) * 100));
      progressFill.style.width = `${pct}%`;
      progressText.innerHTML = `Add <strong>Rs. ${remaining.toLocaleString()}</strong> more for <strong>FREE Delivery</strong>!`;
    }
  }

  updateHeaderCartCount();
}

window.updateItemQty = function(idx, change) {
  if (!CartState.items[idx]) return;
  CartState.items[idx].qty += change;
  if (CartState.items[idx].qty <= 0) {
    CartState.items.splice(idx, 1);
  }
  renderCart();
};

function updateHeaderCartCount() {
  const totalCount = CartState.items.reduce((sum, item) => sum + item.qty, 0);
  document.querySelectorAll(".cart-count-badge").forEach(badge => {
    badge.textContent = totalCount;
  });
}

/**
 * 8. 1-Click Cash on Delivery (COD) Quick Order Modal
 */
function initCodQuickOrder() {
  const modal = document.getElementById("CodOrderModal");
  const closeBtn = document.getElementById("CodModalClose");
  const form = document.getElementById("CodOrderForm");

  if (!modal) return;

  document.addEventListener("click", e => {
    const codBtn = e.target.closest('[data-action="quick-cod"]');
    if (!codBtn) return;
    e.preventDefault();

    const title = codBtn.getAttribute("data-title") || "Rahat Store Skincare Item";
    const price = parseInt(codBtn.getAttribute("data-price") || "3450", 10);
    const image = codBtn.getAttribute("data-image") || "assets/images/cerave/cerave-340g-1.webp";
    const variant = codBtn.getAttribute("data-variant") || "Standard Size";

    document.getElementById("CodPreviewImg").src = image;
    document.getElementById("CodPreviewTitle").textContent = title;
    document.getElementById("CodPreviewPrice").textContent = `Rs. ${price.toLocaleString()}`;
    document.getElementById("CodPreviewVariant").textContent = variant;
    document.getElementById("CodProductPrice").value = price;
    document.getElementById("CodQty").value = 1;

    updateCodSummary(price, 1);
    modal.classList.add("active");
  });

  if (closeBtn) closeBtn.addEventListener("click", () => modal.classList.remove("active"));
  modal.addEventListener("click", e => {
    if (e.target === modal) modal.classList.remove("active");
  });

  const qtyInput = document.getElementById("CodQty");
  if (qtyInput) {
    qtyInput.addEventListener("change", () => {
      const price = parseInt(document.getElementById("CodProductPrice").value || "3450", 10);
      const qty = Math.max(1, parseInt(qtyInput.value || "1", 10));
      updateCodSummary(price, qty);
    });
  }

  if (form) {
    form.addEventListener("submit", e => {
      e.preventDefault();
      const submitBtn = document.getElementById("CodSubmitBtn");
      const name = document.getElementById("CodCustomerName").value.trim();
      const phone = document.getElementById("CodCustomerPhone").value.trim();
      const city = document.getElementById("CodCustomerCity").value.trim();
      const address = document.getElementById("CodCustomerAddress").value.trim();

      if (!name || !phone || !city || !address) {
        alert("Please fill out all required delivery fields.");
        return;
      }

      submitBtn.disabled = true;
      submitBtn.innerHTML = `<span>⏳ Processing Order...</span>`;

      setTimeout(() => {
        const orderId = "RS-" + Math.floor(100000 + Math.random() * 900000);
        modal.classList.remove("active");
        submitBtn.disabled = false;
        submitBtn.innerHTML = `<span>⚡ Buy It Now (Confirm Order)</span>`;

        alert(`🎉 ORDER CONFIRMED! (Order #${orderId})

Thank you, ${name}!
Your Cash on Delivery order at Rahat Store has been successfully registered.

📍 Delivery to: ${address}, ${city}
📞 Contact: ${phone}
🚚 Dispatch: Within 24 Hours with 100% Discreet & Sealed Packaging.
💵 Payment: Hand over cash to courier upon arrival.`);

        form.reset();
      }, 1200);
    });
  }
}

function updateCodSummary(unitPrice, qty) {
  const subtotal = unitPrice * qty;
  const shipping = subtotal >= CartState.threshold ? 0 : CartState.shippingFee;
  const total = subtotal + shipping;

  const subtotalEl = document.getElementById("CodSummarySubtotal");
  const shippingEl = document.getElementById("CodSummaryShipping");
  const totalEl = document.getElementById("CodSummaryTotal");

  if (subtotalEl) subtotalEl.textContent = `Rs. ${subtotal.toLocaleString()}`;
  if (shippingEl) shippingEl.textContent = shipping === 0 ? "FREE" : `Rs. ${shipping}`;
  if (totalEl) totalEl.textContent = `Rs. ${total.toLocaleString()}`;
}

/**
 * 9. "View All Products" Button Action
 */
function initViewAllProducts() {
  const btn = document.getElementById("ViewAllProductsBtn");
  const hiddenCards = document.querySelectorAll(".product-card.hidden-catalog-item");

  if (!btn) return;

  btn.addEventListener("click", e => {
    e.preventDefault();
    if (hiddenCards.length) {
      hiddenCards.forEach(card => {
        card.classList.remove("hidden-catalog-item");
        card.style.display = "flex";
      });
      btn.innerHTML = "<span>✨ All Products Displayed</span>";
      btn.style.opacity = "0.7";
      btn.style.pointerEvents = "none";
    }
  });
}

/**
 * 10. Bra & Undergarment Size Calculator Modal
 */
function initSizeCalculator() {
  const modal = document.getElementById("SizeGuideModal");
  const openBtns = document.querySelectorAll('[data-action="open-size-guide"]');
  const closeBtn = document.getElementById("SizeGuideClose");
  const calcBtn = document.getElementById("CalculateSizeBtn");

  if (!modal) return;

  openBtns.forEach(btn => btn.addEventListener("click", e => {
    e.preventDefault();
    modal.classList.add("active");
  }));

  if (closeBtn) closeBtn.addEventListener("click", () => modal.classList.remove("active"));
  modal.addEventListener("click", e => {
    if (e.target === modal) modal.classList.remove("active");
  });

  if (calcBtn) {
    calcBtn.addEventListener("click", () => {
      const underbust = parseFloat(document.getElementById("UnderbustInput").value || "0");
      const bust = parseFloat(document.getElementById("BustInput").value || "0");

      if (!underbust || !bust || bust <= underbust) {
        alert("Please enter valid measurements (Bust size should be larger than Underbust).");
        return;
      }

      let band = Math.round(underbust);
      if (band % 2 !== 0) band += 1;

      const diff = bust - underbust;
      let cup = "A";
      if (diff >= 0.5 && diff < 1.5) cup = "A";
      else if (diff >= 1.5 && diff < 2.5) cup = "B";
      else if (diff >= 2.5 && diff < 3.5) cup = "C";
      else if (diff >= 3.5 && diff < 4.5) cup = "D";
      else if (diff >= 4.5 && diff < 5.5) cup = "DD";
      else if (diff >= 5.5) cup = "E";

      const primarySize = `${band}${cup}`;
      const sisterSize = `${band + 2}${cup === "C" ? "B" : cup === "B" ? "A" : "C"}`;

      const resBox = document.getElementById("CalculatorResultBox");
      if (resBox) {
        resBox.style.display = "block";
        document.getElementById("CalculatedPrimarySize").textContent = primarySize;
        document.getElementById("CalculatedSisterSize").textContent = sisterSize;
      }
    });
  }
}

/**
 * 11. Recent Sales Social Proof Notification Toast
 */
function initRecentSalesPopup() {
  const toast = document.getElementById("RecentSalesToast");
  if (!toast) return;

  const mockPurchases = [
    {
      name: "Fatima A.",
      city: "Lahore",
      product: "CeraVe Moisturising Cream (340g Family Tub)",
      time: "2 mins ago",
      img: "assets/images/cerave/cerave-340g-1.webp"
    },
    {
      name: "Ayesha N.",
      city: "Karachi",
      product: "COSRX Advanced Snail 96 Mucin Power Essence (100ml)",
      time: "4 mins ago",
      img: "assets/images/catalog/IMG-20260910-WA0055.jpg"
    },
    {
      name: "Sana K.",
      city: "Islamabad",
      product: "Seamless Comfort Wire-Free Everyday Bra",
      time: "6 mins ago",
      img: "assets/images/undergarments/seamless-bra.jpg"
    },
    {
      name: "Zainab M.",
      city: "Rawalpindi",
      product: "Mielle Rosemary Mint Hair Strengthening Shampoo",
      time: "9 mins ago",
      img: "assets/images/catalog/IMG-20260910-WA0038.jpg"
    },
    {
      name: "Hina R.",
      city: "Faisalabad",
      product: "Estée Lauder Advanced Night Repair (100ml)",
      time: "12 mins ago",
      img: "assets/images/catalog/IMG-20260910-WA0051.jpg"
    }
  ];

  let index = 0;

  function showNextToast() {
    const item = mockPurchases[index];
    index = (index + 1) % mockPurchases.length;

    const imgEl = document.getElementById("ToastImg");
    const nameEl = document.getElementById("ToastName");
    const prodEl = document.getElementById("ToastProduct");
    const timeEl = document.getElementById("ToastTime");

    if (imgEl) imgEl.src = getShopifyAssetUrl(item.img);
    if (nameEl) nameEl.textContent = `${item.name} (${item.city})`;
    if (prodEl) prodEl.textContent = item.product;
    if (timeEl) timeEl.textContent = `Purchased via COD • ${item.time}`;

    toast.classList.add("show");

    setTimeout(() => {
      toast.classList.remove("show");
    }, 4500);
  }

  setTimeout(() => {
    showNextToast();
    setInterval(showNextToast, 14000);
  }, 4000);
}

/**
 * 12. Categories Mega Modal & Trigger Handler
 */
function initCategoriesModal() {
  const modal = document.getElementById('CategoriesModal');
  const navBtn = document.getElementById('CategoriesNavBtn');
  const openTriggers = document.querySelectorAll('[data-action="open-categories-modal"]');
  const closeTriggers = document.querySelectorAll('[data-action="close-categories-modal"]');

  if (!modal) return;

  function openModal() {
    modal.classList.add('active');
    if (navBtn) navBtn.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('active');
    if (navBtn) navBtn.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (navBtn) {
    navBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal.classList.contains('active')) {
        closeModal();
      } else {
        openModal();
      }
    });
  }

  openTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      closeModal();
    });
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
}

/**
 * 13. Category Quick-Nav Sticky Bar Active Scroll Tracking
 */
function initCategoryQuickBar() {
  const bar = document.getElementById('CategoryQuickBar');
  if (!bar) return;

  const chips = bar.querySelectorAll('.quick-cat-chip[href^="#"]');
  const sections = Array.from(chips).map(chip => {
    const id = chip.getAttribute('href').substring(1);
    return document.getElementById(id);
  }).filter(Boolean);

  window.addEventListener('scroll', () => {
    let currentId = '';
    const scrollPos = window.scrollY + 180;

    sections.forEach(sec => {
      if (sec.offsetTop <= scrollPos) {
        currentId = sec.id;
      }
    });

    if (currentId) {
      chips.forEach(chip => {
        if (chip.getAttribute('href') === '#' + currentId) {
          chip.classList.add('active');
        } else if (!chip.classList.contains('highlight')) {
          chip.classList.remove('active');
        }
      });
    }
  }, { passive: true });
}

// Expose RahatStore & GlowVibes global helper for product pages and custom buttons
window.RahatStore = {
  addToBag: function(variantId, qty, title, priceStr, imgUrl) {
    qty = qty || 1;
    var numPrice = parseInt(String(priceStr).replace(/[^0-9]/g, '')) || 1800;
    
    // 1. Update local CartState
    var existing = CartState.items.find(function(item) { return String(item.id) === String(variantId); });
    if (existing) {
      existing.qty += qty;
    } else {
      CartState.items.push({
        id: variantId,
        title: title || "Rahat Store Beauty Item",
        price: numPrice,
        qty: qty,
        image: imgUrl || "assets/images/cerave/cerave-340g-1.webp",
        variant: "Default"
      });
    }

    // 2. Sync with real Shopify AJAX Cart if available
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function(res) { return res.json(); })
        .then(function(data) { console.log('Shopify Cart Updated:', data); })
        .catch(function(err) { console.log('Local cart used'); });
    } catch(e) {}

    // 3. Open Drawer
    var drawer = document.getElementById("CartDrawer");
    var overlay = document.getElementById("CartDrawerOverlay");
    if (drawer && overlay) {
      drawer.classList.add("active");
      overlay.classList.add("active");
      renderCart();
      updateHeaderCartCount();
    }
  },

  openCodModal: function(title, priceStr, imgUrl, variantId) {
    var modal = document.getElementById("CodOrderModal");
    if (!modal) return;
    var numPrice = parseInt(String(priceStr).replace(/[^0-9]/g, '')) || 1800;

    var previewImg = document.getElementById("CodPreviewImg");
    var previewTitle = document.getElementById("CodPreviewTitle");
    var previewPrice = document.getElementById("CodPreviewPrice");
    var previewVariant = document.getElementById("CodPreviewVariant");
    var productPriceInput = document.getElementById("CodProductPrice");
    var qtyInput = document.getElementById("CodQty");

    if (previewImg && imgUrl) previewImg.src = imgUrl;
    if (previewTitle && title) previewTitle.textContent = title;
    if (previewPrice) previewPrice.textContent = 'Rs. ' + numPrice.toLocaleString();
    if (previewVariant) previewVariant.textContent = 'Standard / Selected Option';
    if (productPriceInput) productPriceInput.value = numPrice;
    if (qtyInput) qtyInput.value = 1;

    updateCodSummary(numPrice, 1);
    modal.classList.add("active");
  }
};

window.GlowVibes = window.RahatStore;
